import React from "react";
import { Box, Hidden, makeStyles } from "@material-ui/core";

import { Paragraph, Title } from "../Typography";

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: theme.shape.borderRadius,
  },
  content: {
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3),
    },
  },
}));

const FinalStep = ({ message, description }) => {
  const classes = useStyles();

  return (
    <Box>
      <Hidden mdUp>
        <Box px={2}>
          <Title text={message} />
        </Box>
      </Hidden>

      <Box className={classes.container}>
        <Hidden smDown>
          <Box mb={3}>
            <Title text={message} />
          </Box>
        </Hidden>
        <Box className={classes.content}>
          <Paragraph text={description} />
        </Box>
      </Box>
    </Box>
  );
};

export default FinalStep;
